import styled from "styled-components";

export const VoucherCardBackContentBox = styled.div`
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  flex-grow: 1;
  font-size: 1.5rem;
  line-height: 1.3;
`